module.exports = __webpack_public_path__ + "img/11.3fd01644.jpg";